<template>
  <div class="RequestTasksComponent">
    <p v-if="!isData">{{lang.infotext_1}}</p>
    
    
    <div v-if="isData">

      <p>{{lang.infotext_2}}:</p>

      <div>

        <div class="list-details">
          <b-list-group>
            
            <b-list-group-item>{{lang.label_StageName}}: {{requestDetails.stage}}</b-list-group-item>
            <b-list-group-item  v-for="item in tasks" :key="item.type">
              <p>{{ item.label }}</p>
              
              <span class="task-buttons">

                <b-button @click="checkIfLibrariesReady(item)" size="sm" id="task_event" class="task-button-input"
                  :variant="item.variant" :disabled="item.disabled"><b-spinner v-show="item.isSpinner" small></b-spinner> {{item.buttonName}}</b-button>
                
              </span>

            </b-list-group-item>
            
          </b-list-group>
        </div>
        <br>
        
      </div>


    </div>
    <br>
    <RequestHistoryCommentsComponent :lang="lang.DetailsHistory" parent=""></RequestHistoryCommentsComponent>


  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import * as Tools from '@/Tools/Tools';
  import RequestHistoryCommentsComponent from "@/components/shared/RequestHistoryCommentsComponent"
  import PartPropertiesType from '@/constants/PartPropertiesType'

  export default {
    name: "RequestTasksComponent",
    props: {
      lang: Object,
      parent: String
    },
    components: {

      LoaderComponent,
      RequestHistoryCommentsComponent
      
    },
    data() {
      return {
        name: "RequestTasksComponent" + "_" + this.parent,
        tasks: [],
        basicTasks: [],
        requestDetails: {},
        //taskReason: "",
        isSpinner: false,
      }
    },
    computed: {
      ...mapGetters({

        globalSettings: 'globalSettings'
      }),

      requestId() {

        if (this.parent == "details") {
          return this.$route.query.requestId;
        } else {
          console.log(this.$store.getters.selectedRequestRows)
          if (this.$store.getters.selectedRequestRows.length != 0){
            return this.$store.getters.selectedRequestRows[0].col___requestId.requestId;
                        
          }
        }
        return null;

      },
      revisionId() {

        if (this.parent == "details") {
          return this.$route.query.revisionId;
        } else {
          console.log(this.$store.getters.selectedRequestRows)
          if (this.$store.getters.selectedRequestRows.length > 0) {
            
            if (this.$store.getters.selectedRequestRows[0].col___requestId.type == "library") {
              return this.$store.getters.selectedRequestRows[0].col___requestId.libraryRevisionId;
            }
            return this.$store.getters.selectedRequestRows[0].col___requestId.partRevisionId;
                        
          }
        }
        return null;

      },

      isData() {

        return this.tasks.length != 0

      },
      reloadedAfterActionComplex() {
        return this.$store.getters.reloadedAfterActionComplex;
      },

      
    },
    created() {

      
      this.getRequestDetails();


    },
    watch: {
      requestId: function (newVal) {

        if (newVal != null) {
          this.getRequestDetails();
          
        } 
        


      },
      revisionId: function (newVal,oldVal) {

        if (newVal != null) {
          this.getTasks();
          
        } 
        


      },
      reloadedAfterActionComplex: {
        handler: function (newValue) {

          for (let el in newValue) {

            if (newValue[el].name == this.name) {

              if (newValue[el].status == true) {

                this.getRequestDetails();
                

                newValue[el].status = false;

                this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
              }
            }
          }
        },
        deep: true

      },

    },
    
    methods: {
      
      prepareData() {
        this.tasks = []

       

        if (this.requestDetails.canSubmit) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "submit",
            buttonName: this.lang.button_Submit,
            variant: "success",
            isSpinner: false,
            label: this.lang.label_Submit,
            
          })
        }
        if (this.requestDetails.canCancelRequest) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "cancel",
            buttonName: this.lang.button_Cancel,
            variant: "danger",
            isSpinner: false,
            label: this.lang.label_Cancel,
            
          })
        }
        if (this.requestDetails.canOwnRequest) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "ownRequest",
            buttonName: this.lang.button_Own,
            variant: "success",
            isSpinner: false,
            label: this.lang.label_Own,
            
          })
        }
        if (this.requestDetails.canDisownRequest) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "disownRequest",
            buttonName: this.lang.button_Disown,
            variant: "warning",
            isSpinner: false,
            label: this.lang.label_Disown,
            
          })
        }
        if (this.requestDetails.canReturnToRequester) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "returnToRequester",
            buttonName: this.lang.button_ReturnToRequester,
            variant: "danger",
            isSpinner: false,
            label: this.lang.label_ReturnToRequester,
            
          })
        }
        if (this.requestDetails.canAssignLibrarian) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "assignLibrarian",
            buttonName: this.lang.button_AssignLibrarian,
            variant: "success",
            isSpinner: false,
            label: this.lang.label_AssignLibrarian,
            
          })
        }
        if (this.requestDetails.canStartRequestDevelopment) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "startDevelopment",
            buttonName: this.lang.button_StartDevelopment,
            variant: "success",
            isSpinner: false,
            label: this.lang.label_StartDevelopment,
            
          })
        }
        if (this.requestDetails.canDoneRequestDevelopment) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "doneDevelop",
            buttonName: this.lang.button_DoneDevelop,
            variant: "success",
            //disabled: true,
            isSpinner: false,
            label: this.lang.label_DoneDevelop,
            
          })
        }
        if (this.requestDetails.canReturnRequestForRework) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "reworkRequest",
            buttonName: this.lang.button_Rework,
            variant: "danger",
            isSpinner: false,
            label: this.lang.label_Rework,
            
          })
        }
        if (this.requestDetails.canReleaseRequestForEvaluation) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "evaluationRequest",
            buttonName: this.lang.button_Evaluation,
            variant: "info",
            isSpinner: false,
            label: this.lang.label_Evaluation,
            
          })
        }
        if (this.requestDetails.canReleaseRequestForProduction) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "productionRequest",
            buttonName: this.lang.button_Production,
            variant: "info",
            isSpinner: false,
            label: this.lang.label_Production,
            

          })
        }
        if (this.requestDetails.canWithdrawRequest) {
          this.tasks.push({
            requestDetails: this.requestDetails,
            type: "withdrawRequest",
            buttonName: this.lang.button_Abort,
            variant: "danger",
            isSpinner: false,
            label: this.lang.label_Abort,
            
          })
        }
          
               
        
      },
      
      getRequestDetails() {
        
        let vue = this;

        const obj = {
          requestId: this.requestId
        }

        this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRequest', obj)
          .then((result) => {
              console.log(result)
              if (result.status == "OK") {

                

                

                vue.requestDetails = result.data;

                vue.getTasks();
                vue.prepareData();
                
                
              }
              
          })


        
      },
      spinnerStatus(task, status) {
        this.tasks.forEach(element => {
          
          if (element.type == task.type) {
            element.isSpinner = status;
            
          }
        });
      },
      reloadDependantComponents() {

      

        this.$store.commit("DELETEALLREQUESTSELECTEDROWS");

        let reloadObj = {
          status: true,
          name: "RequestTasksComponent" + "_" + this.parent
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);

        reloadObj = {
          status: true,
          name: "RequestDetailsComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);

        reloadObj = {
          status: true,
          name: "RequestInfoComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);

        reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiRequestsComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);

        reloadObj = {
          status: true,
          name: "RequestHistoryCommentsComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);

        
      },
      displayAlerts(task, result) {
        
        if (result.status == "OK") {
          if (result.data != null) {
            let obj = {
              text: this.lang["alert_success_" + task.type],
              time: 10,
              type: "success"
            }

            this.$store.dispatch("displayFooterAlert", obj);

            this.reloadDependantComponents();
            
          } else {
            let obj = {
              text: this.lang["alert_error_" + task.type],
              time: 15,
              type: "danger"
            }

            this.$store.dispatch("displayFooterAlert", obj);
          }
          

          
        } else {
          
          let obj = {
            text: this.lang["alert_error_" + task.type] + ": " + result.message,
            time: 15,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
          
        }
        
      },
      getTasks(){
      
        let vue = this;
        vue.basicTasks = [];

        let prefix = "pm";
        
        if (vue.requestDetails.type == "library"){
          prefix = "lm";
        }

        const obj = {
          revisionId: this.revisionId
        }

        this.$store.dispatch(prefix + "_getTasks", obj)
        .then((result) => {

          console.log(result)
          if (result.status == "OK"){

            vue.basicTasks = result.data
            

            
          }


        })
      },
      checkIfLibrariesReady(task) {

        let vue = this;

        if (task.type == "doneDevelop" || task.type == "productionRequest") {

          if (vue.revisionId == 0 || vue.revisionId == null || vue.revisionId == "") {

            let objAlert = {
              text: vue.lang.alert_error_complete_task,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", objAlert);
            vue.spinnerStatus(task, false);
            return;
          }

          let obj = {};
        
          let prefix = null;
          if (vue.requestDetails.type == "part"){
            obj.partRevisionId = vue.revisionId;
            prefix = "pm";
          }
          if (vue.requestDetails.type == "library"){
            obj.libraryRevisionId = vue.revisionId;
            prefix = "lm";
          }
          
          
          
          this.$store.dispatch(prefix + "_checkIfLibrariesReady", obj)
            .then((result) => {

              console.log(result)

              

              if (result.data.length > 0) {

                let funcCustom = function () {
                  
                  
                  //return false;

                }

                

                const objModal = {

                  text: "",
                  type: "eventtaskValidation",
                  buttons: 1,
                  buttonName: "Close",
                  size: "xl",
                  lang: vue.lang.modal_EventTaskFormValidation,
                  data: result.data,
                  funcNo: "",
                  funcOk: "",
                  funcCustom: funcCustom
                };

                vue.$store.dispatch("showModalComponent", objModal);

              } else {
                vue.eventTask(task);
              }
            })
        } else {
          vue.eventTask(task);
        }

        
      },
      goto(task) {

        if (task.type == "cancel") {

          this.$store.commit("RESETROUTINGDATA");

          
          this.$store.commit("RESETPROPERTYREQUESTTOSAVING");
          this.$store.commit("DELETEALLREQUESTSELECTEDROWS");
                  

          let to = "/RequestManager/RequestTable";
          
          this.$router.push({ path: to });
        }
      },
      eventTask(task){

        let vue = this;

        

        
        
                
        vue.spinnerStatus(task, true);

        let obj = {
          requestId: this.requestId,
          stage: task.requestDetails.stage
        }
        
        
        if (task.type == "submit") {
          
          this.$store.dispatch(this.$store.getters.sectionPrefix + '_submitRequest', obj)
            .then((result) => {
            
              console.log(result)
              vue.spinnerStatus(task, false);
             
              vue.displayAlerts(task, result);
                 
              
          })
        }
        if (task.type == "cancel") {
          
          function funcYes() {

            
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + '_cancelRequest', obj)
            .then((result) => {
            
              console.log(result)
              vue.spinnerStatus(task, false);
              
              vue.displayAlerts(task, result);

              vue.goto(task);
                
            })

            
          }
          function funcNo() {
            vue.spinnerStatus(task, false);
          }

          const objAlert = {
            title: vue.lang.modal_title_delete,
            text: vue.lang.alert_Cancel,
            type: "sure",
            buttons: 2,
            size: "sm",
            funcYes: funcYes,
            funcNo: funcNo,
          };

      this.$store.dispatch("showAlert", objAlert);
          
        }
        if (task.type == "assignLibrarian") {

          function funcYes() {


            obj.userId = vue.$store.getters.selectedAssignUser.userId;
            
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + '_assignLibrarian', obj)
            .then((result) => {
            
              console.log(result)
                vue.spinnerStatus(task, false);
              
                vue.displayAlerts(task, result);
                
            })

            
          }
          function funcNo() {
            vue.spinnerStatus(task, false);
          }

          const objModal = {
            text: "",
            type: "assign_user",
            buttons: 2,
            //buttonName: "Close",
            buttonWait: null,
            commentWait: null,
            size: "lm",
            lang: vue.lang.modal_AssignUser,
            funcYes: funcYes,
            funcNo: funcNo,
            funcCustom: "",
            data: null
          };
          vue.$store.dispatch("showModalComponent", objModal);

          
        }
        if (task.type == "startDevelopment") {
          this.$store.dispatch(this.$store.getters.sectionPrefix + '_startRequestDevelopment', obj)
            .then((result) => {
            
            console.log(result)
              vue.spinnerStatus(task, false);
             
              vue.displayAlerts(task, result);
              
          })

        }
        if (task.type == "returnToRequester") {

          function funcYes() {


            obj.comment = vue.$store.getters.requestTaskObject.comment;
            
            
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + '_returnToRequester', obj)
            .then((result) => {
            
              console.log(result)
                vue.spinnerStatus(task, false);
              
                vue.displayAlerts(task, result);
                
            })

            
          }
          function funcNo() {
            vue.spinnerStatus(task, false);
          }

          const objModal = {
            text: "",
            type: "comment_request",
            buttons: 2,
            //buttonName: "Close",
            buttonWait: null,
            commentWait: null,
            size: "lm",
            lang: vue.lang.modal_CommentRequest,
            funcYes: funcYes,
            funcNo: funcNo,
            funcCustom: "",
            data: null
          };
          vue.$store.dispatch("showModalComponent", objModal);

          
        }
        if (task.type == "doneDevelop") {

          
          let trig = false;
          for (let i = 0, lei = vue.basicTasks.length; i < lei; i++) {
            if (vue.basicTasks[i].taskName == "Check and complete technical data" || vue.basicTasks[i].taskName == "Approval was rejected. Check and complete technical data.") {
              trig = true;
            }
          }

          if (trig == true) {

            //posible approve
            function funcYes() {

              //approve 1st level
              const objGetElem = {
                revisionId: vue.revisionId,
                
              }
              
              let method = "_getPart";
              let prefix = "pm";
              if (vue.requestDetails.type == "library"){
                method = "_getLibrary";
                prefix = "lm";
              }
              
              vue.$store.dispatch(prefix + method, objGetElem)
              .then((result) => {

                console.log(result)
                if (result.status == "OK"){
                  
                  
                  let trig = true;
                  let field = "";


                  
                  let mechtrig = false;
                  for (let i = 0, lei = result.data.length; i < lei; i++){
                    if (vue.requestDetails.type == "part") {
                        if (result.data[i].type == PartPropertiesType.TYPE && (result.data[i].value.display == "Mechanical" || result.data[i].value.display == "Software")){
                        mechtrig = true;
                      }
                    }
                    if (vue.requestDetails.type == "library") {
                      
                    }
                    

                  }

                  for (let i = 0, lei = result.data.length; i < lei; i++){
                    if (result.data[i].isRequiredOnRelease == true){
                      if (mechtrig == false){
                        
                          if (result.data[i].value == null){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                          if (result.data[i].value.display == ""){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                        
                      }else{
                        
                        if (result.data[i].type != PartPropertiesType.SYMBOL && result.data[i].type != PartPropertiesType.FOOTPRINT && result.data[i].type != PartPropertiesType.HDLSYMBOL){
                          
                          if (result.data[i].value == null){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                          if (result.data[i].value.display == ""){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                          
                          
                        }
                        
                      }
                    
                    }
                  }
                  
                  
                  if (trig == false){
                    
                    let objAlert = {
                      text: vue.lang.alert_error_approve1 + " " + field + " " + vue.lang.alert_error_approve2,
                      time: 15,
                      type: "danger"
                    }

                    vue.$store.dispatch("displayFooterAlert", objAlert);



                  }else{
                    
                    let objSetEvent = {
                      revisionId: vue.revisionId,
                      action: "approved",
                      reason: vue.$store.getters.requestTaskObject.comment,
                      //changeRevisionOfDependentParts: vue.$store.getters.eventTaskForm.changeRevisionOfDependentParts,
                      //indicatedUserId: vue.$store.getters.eventTaskForm.indicatedUserId
                    }
                    
                    vue.$store.dispatch(prefix + "_setEventTask", objSetEvent)
                    .then((result) => {

                      console.log(result)
                      if (result.status == "OK"){

                        
                        if (result.data.length > 0) {
                          

                          let funcCustom = function (_vue) {
                            

                            
                          }


                          let objModalDependency = {

                            text: "",
                            type: "eventtaskdependency",
                            buttons: 1,
                            buttonName: "Close",
                            size: "xl",
                            lang: vue.lang.modal_EventTaskDependencyInfo,
                            data: result.data,
                            funcNo: "",
                            funcOk: "",
                            funcCustom: funcCustom
                            };

                            vue.$store.dispatch("showModalComponent", objModalDependency);


                        }

                        obj.comment = vue.$store.getters.requestTaskObject.comment;
              
                        vue.$store.dispatch(vue.$store.getters.sectionPrefix + '_doneRequestDevelopment', obj)
                        .then((result) => {
                        
                          console.log(result)
                          vue.spinnerStatus(task, false);
                        
                          vue.displayAlerts(task, result);
                          
                        })

                        

                      }else{
                        let obj = {
                          text: vue.lang.alert_error_approve + ": " + result.message,
                          time: 15,
                          type: "danger"
                        }

                        vue.$store.dispatch("displayFooterAlert", obj);


                      }

                    })




                  }
                  

                }
                

              })


              //end approve 1st level

              

              
            }
            function funcNo() {
              vue.spinnerStatus(task, false);
            }

            const objModal = {
              text: "",
              type: "comment_request",
              buttons: 2,
              //buttonName: "Close",
              buttonWait: null,
              commentWait: null,
              size: "lm",
              lang: vue.lang.modal_CommentRequest,
              funcYes: funcYes,
              funcNo: funcNo,
              funcCustom: "",
              data: null
            };
            vue.$store.dispatch("showModalComponent", objModal);

          } else {
            //check if exists library or part

            let obj = {
              text: vue.lang.alert_error_complete_task,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
            vue.spinnerStatus(task, false);
          }


          

          
        }
        if (task.type == "reworkRequest") {

          let trig = false;
          for (let i = 0, lei = vue.basicTasks.length; i < lei; i++) {
            if (vue.basicTasks[i].taskName == "Check and complete technical data" || vue.basicTasks[i].taskName == "Approval was rejected. Check and complete technical data.") {
              trig = true;
            }
          }

          if (trig == true) {
            function funcYes() {

            //reject level 1

            let prefix = "pm";
            if (vue.requestDetails.type == "library"){
              
              prefix = "lm";
            }

            const objEventTask = {
              revisionId: vue.revisionId,
              action: "rejected",
              reason: vue.$store.getters.requestTaskObject.comment,
              
            }
            
            vue.$store.dispatch(prefix + "_setEventTask", objEventTask)
            .then((result) => {

              console.log(result)
              if (result.status == "OK") {

                obj.comment = vue.$store.getters.requestTaskObject.comment;
            
                vue.$store.dispatch(vue.$store.getters.sectionPrefix + '_returnRequestForRework', obj)
                .then((result) => {

                  
                  console.log(result)
                  vue.spinnerStatus(task, false);
                
                  vue.displayAlerts(task, result);
                  
                })
                

              }else{
                let obj = {
                  text: vue.lang.alert_error_reject + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);

                vue.spinnerStatus(task, false);


              }

            })



            //end of reject level 1


            

            
          }
          function funcNo() {
            vue.spinnerStatus(task, false);
          }

          const objModal = {
            text: "",
            type: "comment_request",
            buttons: 2,
            //buttonName: "Close",
            buttonWait: null,
            commentWait: null,
            size: "lm",
            lang: vue.lang.modal_CommentRequest,
            funcYes: funcYes,
            funcNo: funcNo,
            funcCustom: "",
            data: null
          };
          vue.$store.dispatch("showModalComponent", objModal);

            
          } else {
            let obj = {
              text: vue.lang.alert_error_reject_task,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
            vue.spinnerStatus(task, false);
            
          }

          

          
        }
        if (task.type == "evaluationRequest") {

          this.$store.dispatch(this.$store.getters.sectionPrefix + '_releaseRequestForEvaluation', obj)
            .then((result) => {
            
            console.log(result)
              vue.spinnerStatus(task, false);
             
              vue.displayAlerts(task, result);
              
          })
        }
        if (task.type == "productionRequest") {
          
          
          let trig = false;
          for (let i = 0, lei = vue.basicTasks.length; i < lei; i++) {
            if (vue.basicTasks[i].taskName == "Check and complete technical data" || vue.basicTasks[i].taskName == "Approval was rejected. Check and complete technical data.") {
              trig = true;
            }
          }

          if (trig == true) {

            //posible approve
            function funcYes() {

              //approve 1st level
              const objGetElem = {
                revisionId: vue.revisionId,
                
              }
              
              let method = "_getPart";
              let prefix = "pm";
              if (vue.requestDetails.type == "library"){
                method = "_getLibrary";
                prefix = "lm";
              }
              
              vue.$store.dispatch(prefix + method, objGetElem)
              .then((result) => {

                console.log(result)
                if (result.status == "OK"){
                  
                  
                  let trig = true;
                  let field = "";


                  
                  let mechtrig = false;
                  for (let i = 0, lei = result.data.length; i < lei; i++){
                    if (vue.requestDetails.type == "part") {
                        if (result.data[i].type == PartPropertiesType.TYPE && (result.data[i].value.display == "Mechanical" || result.data[i].value.display == "Software")){
                        mechtrig = true;
                      }
                    }
                    if (vue.requestDetails.type == "library") {
                      
                    }
                    

                  }

                  for (let i = 0, lei = result.data.length; i < lei; i++){
                    if (result.data[i].isRequiredOnRelease == true){
                      if (mechtrig == false){
                        
                          if (result.data[i].value == null){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                          if (result.data[i].value.display == ""){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                        
                      }else{
                        
                        if (result.data[i].type != PartPropertiesType.SYMBOL && result.data[i].type != PartPropertiesType.FOOTPRINT && result.data[i].type != PartPropertiesType.HDLSYMBOL){
                          
                          if (result.data[i].value == null){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                          if (result.data[i].value.display == ""){
                            field = result.data[i].name;
                            trig = false;
                            break;
                          }
                          
                          
                        }
                        
                      }
                    
                    }
                  }
                  
                  
                  if (trig == false){
                    
                    let objAlert = {
                      text: vue.lang.alert_error_approve1 + " " + field + " " + vue.lang.alert_error_approve2,
                      time: 15,
                      type: "danger"
                    }

                    vue.$store.dispatch("displayFooterAlert", objAlert);



                  }else{
                    
                    let objSetEvent = {
                      revisionId: vue.revisionId,
                      action: "approved",
                      reason: vue.$store.getters.requestTaskObject.comment,
                      //changeRevisionOfDependentParts: vue.$store.getters.eventTaskForm.changeRevisionOfDependentParts,
                      //indicatedUserId: vue.$store.getters.eventTaskForm.indicatedUserId
                    }
                    
                    vue.$store.dispatch(prefix + "_setEventTask", objSetEvent)
                    .then((result) => {

                      console.log(result)
                      if (result.status == "OK"){

                        
                        if (result.data.length > 0) {
                          

                          let funcCustom = function (_vue) {
                            

                            
                          }


                          let objModalDependency = {

                            text: "",
                            type: "eventtaskdependency",
                            buttons: 1,
                            buttonName: "Close",
                            size: "xl",
                            lang: vue.lang.modal_EventTaskDependencyInfo,
                            data: result.data,
                            funcNo: "",
                            funcOk: "",
                            funcCustom: funcCustom
                            };

                            vue.$store.dispatch("showModalComponent", objModalDependency);


                        }

                        obj.comment = vue.$store.getters.requestTaskObject.comment;
            
                        vue.$store.dispatch(vue.$store.getters.sectionPrefix + '_releaseRequestForProduction', obj)
                        .then((result) => {
                        
                          console.log(result)
                          vue.spinnerStatus(task, false);
                        
                          vue.displayAlerts(task, result);
                          
                        })

                        

                      }else{
                        let obj = {
                          text: vue.lang.alert_error_approve + ": " + result.message,
                          time: 15,
                          type: "danger"
                        }

                        vue.$store.dispatch("displayFooterAlert", obj);

                        vue.spinnerStatus(task, false);
                      }

                    })




                  }
                  

                }
                

              })


              //end approve 1st level

              

              
            }
            function funcNo() {
              vue.spinnerStatus(task, false);
            }

            const objModal = {
              text: "",
              type: "comment_request",
              buttons: 2,
              //buttonName: "Close",
              buttonWait: null,
              commentWait: null,
              size: "lm",
              lang: vue.lang.modal_CommentRequest,
              funcYes: funcYes,
              funcNo: funcNo,
              funcCustom: "",
              data: null
            };
            vue.$store.dispatch("showModalComponent", objModal);

          } else {
            //check if exists library or part

            let obj = {
              text: vue.lang.alert_error_complete_task,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
            vue.spinnerStatus(task, false);
          }


                    
        }
        if (task.type == "withdrawRequest") {

          function funcYes() {


            obj.comment = vue.$store.getters.requestTaskObject.comment;
            
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + '_withdrawRequest', obj)
            .then((result) => {
            
              console.log(result)
              vue.spinnerStatus(task, false);
             
              vue.displayAlerts(task, result);
              
            })

            
          }
          function funcNo() {
            vue.spinnerStatus(task, false);
          }

          const objModal = {
            text: "",
            type: "comment_request",
            buttons: 2,
            //buttonName: "Close",
            buttonWait: null,
            commentWait: null,
            size: "lm",
            lang: vue.lang.modal_CommentRequest,
            funcYes: funcYes,
            funcNo: funcNo,
            funcCustom: "",
            data: null
          };
          vue.$store.dispatch("showModalComponent", objModal);

          
        }
        if (task.type == "ownRequest") {
          
          this.$store.dispatch(this.$store.getters.sectionPrefix + '_ownRequest', obj)
            .then((result) => {
            
            console.log(result)
              vue.spinnerStatus(task, false);
             
              vue.displayAlerts(task, result);
              
          })
        }
        if (task.type == "disownRequest") {
          
          this.$store.dispatch(this.$store.getters.sectionPrefix + '_disownRequest', obj)
            .then((result) => {
            
            console.log(result)
              vue.spinnerStatus(task, false);
             
              vue.displayAlerts(task, result);
              
          })
        }
         
      },

    },
    
  }
</script>
<style lang="scss">
.RequestTasksComponent {
  .task-buttons{
    margin-left: 20px;
    
  }
  .task-button-input{
    margin-bottom: 10px;
  }
  .task-reason-text{
    margin-left: 20px;
  }
  .list-group-item{
    margin-top: 5px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/shared/RequestTasksComponent.vue